/**
 * @file MemberZoneLayout.js
 * @module src/js/layouts/MemberZoneLayout
 * @description
 * **Layout for the Member Zone header and nested content area.**
 *
 * - Renders a section wrapper (`.wrapper.style4`).
 * - Displays the section title and a `<DropDownMenu />`.
 * - `dropDownContent` is provided as an Markdown string and is rendered as-is by `DropDownMenu`.
 * - Hosts child routes via React Router’s `<Outlet />` (e.g., Profile, Contact, Archives, Lab Data, Paper Review, New Member).
 *
 * @version
 * <p>
 *  2025-07-22: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-10-18: Docs update: clarify zero bottom padding, HTML `dropDownContent`, and spacing notes. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-11-29: More readable formatting in `dropDownContent`. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { Outlet } from "react-router-dom";
import DropDownMenu from "../components/DropDownMenu";

export default function MemberZoneLayout() {
    return (
        <section id="member-zone" className="wrapper style4" style={{ paddingTop: '4em', paddingBottom: '0em' }}>
            <div className="inner">
                <header className="major special" style={{ marginBottom: '0.5em' }}>
                    <DropDownMenu
                        title="Member Zone" // Introduce six sub-menu items with text intro
                        dropDownContent={[
                            'Profile: 個人資料',
                            'Contact: 成員聯絡資訊',
                            'Archives: 畢業成員的程式與論文',
                            'Lab Data: 資源、公告與手冊',
                            'Paper Review: Group Meeting 論文與投影片',
                            'New Member: 新成員帳號建立'
                        ].join('<br/>')} // Use HTML line breaks for spacing
                        top="50%"
                        left="50%"
                    />
                </header>
            </div>
            {/* This renders child routes like "/member-zone/..." */}
            <Outlet />
        </section>
    );
}
